class BstAboutUsColumnsSlider {
  constructor(section) {
    this.section = section;
    this.wrapper = section.querySelector('.bst-about-us-columns-slider__wrapper');
    this.prevBtn = section.querySelector('.bst-about-us-columns-slider__arrow--prev');
    this.nextBtn = section.querySelector('.bst-about-us-columns-slider__arrow--next');
    this.arrowsContainer = section.querySelector('.bst-about-us-columns-slider__arrows');

    if (!this.wrapper) return;

    this.sliderMobileOnly = this.wrapper.dataset.sliderMobileOnly === 'true';
    this.mobileSlides = this.wrapper.dataset.mobileSlides;
    this.showPartial = this.wrapper.dataset.showPartial === 'true';
    this.desktopStyle = this.wrapper.dataset.desktopStyle;
    this.breakpoint = 750;
    this.flickityInstance = null;

    this.init();
  }

  getFlickityOptions(isMobile) {
    const baseOptions = {
      cellAlign: 'left',
      contain: true,
      prevNextButtons: false,
      pageDots: true,
      wrapAround: false
    };

    if (isMobile) {
      if (this.mobileSlides === '1') {
        baseOptions.cellAlign = 'center';
        if (this.showPartial) {
          baseOptions.cellAlign = 'left';
        }
      } else if (this.mobileSlides === '2') {
        baseOptions.cellAlign = 'left';
      }
    } else {
      if (this.desktopStyle === 'centered') {
        baseOptions.cellAlign = 'center';
        baseOptions.wrapAround = true;
        baseOptions.contain = false;
      }
    }

    return baseOptions;
  }

  updateArrowsVisibility() {
    if (this.arrowsContainer) {
      if (this.flickityInstance) {
        this.arrowsContainer.style.display = '';
      } else {
        this.arrowsContainer.style.display = 'none';
      }
    }
  }

  initSlider() {
    const isMobile = window.innerWidth < this.breakpoint;

    if (this.sliderMobileOnly) {
      if (isMobile && !this.flickityInstance) {
        this.flickityInstance = new Flickity(this.wrapper, this.getFlickityOptions(true));
      } else if (!isMobile && this.flickityInstance) {
        this.flickityInstance.destroy();
        this.flickityInstance = null;
      }
    } else {
      if (!this.flickityInstance) {
        this.flickityInstance = new Flickity(this.wrapper, this.getFlickityOptions(isMobile));
      } else {
        this.flickityInstance.destroy();
        this.flickityInstance = new Flickity(this.wrapper, this.getFlickityOptions(isMobile));
      }
    }

    this.updateArrowsVisibility();
  }

  handleResize() {
    this.initSlider();
  }

  bindEvents() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        if (this.flickityInstance) {
          this.flickityInstance.previous();
        }
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        if (this.flickityInstance) {
          this.flickityInstance.next();
        }
      });
    }

    this.resizeHandler = () => {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => this.handleResize(), 250);
    };

    window.addEventListener('resize', this.resizeHandler);
  }

  init() {
    this.bindEvents();
    this.initSlider();
  }

  destroy() {
    if (this.flickityInstance) {
      this.flickityInstance.destroy();
      this.flickityInstance = null;
    }
    window.removeEventListener('resize', this.resizeHandler);
  }

  refresh() {
    this.destroy();
    this.wrapper = this.section.querySelector('.bst-about-us-columns-slider__wrapper');
    this.prevBtn = this.section.querySelector('.bst-about-us-columns-slider__arrow--prev');
    this.nextBtn = this.section.querySelector('.bst-about-us-columns-slider__arrow--next');
    this.arrowsContainer = this.section.querySelector('.bst-about-us-columns-slider__arrows');

    if (!this.wrapper) return;

    this.sliderMobileOnly = this.wrapper.dataset.sliderMobileOnly === 'true';
    this.mobileSlides = this.wrapper.dataset.mobileSlides;
    this.showPartial = this.wrapper.dataset.showPartial === 'true';
    this.desktopStyle = this.wrapper.dataset.desktopStyle;

    this.init();
  }
}

// Store instances by section ID
const bstAboutUsColumnsSlidersInstances = {};

function initBstAboutUsColumnsSlider(sectionId) {
  const section = document.querySelector(`.section-${sectionId}`);
  if (section) {
    // Destroy existing instance if it exists
    if (bstAboutUsColumnsSlidersInstances[sectionId]) {
      bstAboutUsColumnsSlidersInstances[sectionId].destroy();
    }
    bstAboutUsColumnsSlidersInstances[sectionId] = new BstAboutUsColumnsSlider(section);
  }
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.bst-about-us-columns-slider').forEach(section => {
    const sectionId = Array.from(section.classList)
      .find(cls => cls.startsWith('section-'))
      ?.replace('section-', '');
    if (sectionId) {
      bstAboutUsColumnsSlidersInstances[sectionId] = new BstAboutUsColumnsSlider(section);
    }
  });
});

// Shopify Theme Editor Events
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    const section = event.target.querySelector('.bst-about-us-columns-slider');
    if (section) {
      const sectionId = Array.from(section.classList)
        .find(cls => cls.startsWith('section-'))
        ?.replace('section-', '');
      if (sectionId) {
        initBstAboutUsColumnsSlider(sectionId);
      }
    }
  });

  document.addEventListener('shopify:section:unload', function(event) {
    const section = event.target.querySelector('.bst-about-us-columns-slider');
    if (section) {
      const sectionId = Array.from(section.classList)
        .find(cls => cls.startsWith('section-'))
        ?.replace('section-', '');
      if (sectionId && bstAboutUsColumnsSlidersInstances[sectionId]) {
        bstAboutUsColumnsSlidersInstances[sectionId].destroy();
        delete bstAboutUsColumnsSlidersInstances[sectionId];
      }
    }
  });

  document.addEventListener('shopify:section:select', function(event) {
    const section = event.target.querySelector('.bst-about-us-columns-slider');
    if (section) {
      const sectionId = Array.from(section.classList)
        .find(cls => cls.startsWith('section-'))
        ?.replace('section-', '');
      if (sectionId && bstAboutUsColumnsSlidersInstances[sectionId]) {
        bstAboutUsColumnsSlidersInstances[sectionId].refresh();
      }
    }
  });

  document.addEventListener('shopify:block:select', function(event) {
    const section = event.target.closest('.bst-about-us-columns-slider');
    if (section) {
      const sectionId = Array.from(section.classList)
        .find(cls => cls.startsWith('section-'))
        ?.replace('section-', '');
      if (sectionId && bstAboutUsColumnsSlidersInstances[sectionId]) {
        const instance = bstAboutUsColumnsSlidersInstances[sectionId];
        if (instance.flickityInstance) {
          const slideIndex = Array.from(event.target.parentElement.children).indexOf(event.target);
          instance.flickityInstance.select(slideIndex);
        }
      }
    }
  });

  document.addEventListener('shopify:block:deselect', function(event) {
    const section = event.target.closest('.bst-about-us-columns-slider');
    if (section) {
      const sectionId = Array.from(section.classList)
        .find(cls => cls.startsWith('section-'))
        ?.replace('section-', '');
      if (sectionId && bstAboutUsColumnsSlidersInstances[sectionId]) {
        bstAboutUsColumnsSlidersInstances[sectionId].refresh();
      }
    }
  });
}
